import React, { Fragment, useState, useEffect } from "react";
import { withAITracking } from '@microsoft/applicationinsights-react-js';
import { ai } from '../../../appInsights';
import { createBrowserHistory } from "history";

const TelemetryProvider = (props:any) => {

    const [initialized, setInitialized] = useState(false);

    const browserHistory = createBrowserHistory({ window }); 
    const { children } = props;
    useEffect(() => {
        if (props?.isAppInsightsEnabled) {
            const AppInsightsInstrumentationKey = props.instrumentationKey;
            // PUT YOUR KEY HERE
            if (!initialized && Boolean(AppInsightsInstrumentationKey) && Boolean(browserHistory)) {
                ai.initialize(AppInsightsInstrumentationKey, browserHistory);
                setInitialized(true);
            }
            props.after();
        }
    }, []);

        return (
            <Fragment>
                {children}
            </Fragment>
        );

}

export default (withAITracking(ai.reactPlugin, TelemetryProvider));